import type { SearchMode } from '../types/search-mode.type';

// Boolean operators are matched uppercase-only: lowercase 'and'/'or'/'not' occur
// constantly in natural phrasing ("forklift or pallet jack operator") and must stay in
// natural mode. The BE Boolean parser is case-insensitive, so this FE gate is what keeps
// natural English out of keyword/Boolean search.
const BOOL_TOKEN = /\b(AND|OR|NOT)\b/;
// Elastic simple_query_string signals: a leading +/- attached to a term (+PLC, -trainee),
// and a pipe between terms whether or not it is space-padded (welder|fitter, welder | fitter).
// A +/- directly before a digit is a quantity ("+5 years", "-2 days"), not an operator.
const SQS_OPERATOR = /(^|\s)[+\-](?!\d)\S|\S\s*\|\s*\S/;
// A quoted phrase implies Boolean phrase semantics, e.g. "PLC programming". Curly quotes
// (pasted from formatted text) are normalized to straight quotes before this runs.
const QUOTED_PHRASE = /"[^"]+"/;

type TypedSearchMode = Exclude<SearchMode, 'job'>;

export function detectTypedMode(input: string): TypedSearchMode {
  const normalized = input.replace(/[“”]/g, '"');
  const isBoolean =
    BOOL_TOKEN.test(normalized) || SQS_OPERATOR.test(normalized) || QUOTED_PHRASE.test(normalized);
  return isBoolean ? 'keyword_boolean' : 'natural';
}
